import { render } from "./SetGender.vue?vue&type=template&id=b015fa9a&scoped=true"
import script from "./SetGender.vue?vue&type=script&lang=js"
export * from "./SetGender.vue?vue&type=script&lang=js"

import "./SetGender.vue?vue&type=style&index=0&id=b015fa9a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b015fa9a"]])

export default __exports__